import ko from 'knockout';
import $ from 'jquery';

ko.bindingHandlers.slideVisible = {
    init: function (element, valueAccessor) {
        $(element).toggle(ko.utils.unwrapObservable(valueAccessor()));
    },
    update: function (element, valueAccessor) {
        ko.utils.unwrapObservable(valueAccessor())
            ? $(element).slideDown()
            : $(element).slideUp();
    }
};
